<template>
  <div>
    <v-dialog v-model="show" persistent max-width="50%">
      <v-card>
        <v-card-text class="pa-0">
          <v-container>
            <v-layout row wrap class="pa-4">
              <v-flex xs12>
                <v-radio-group v-model="type" row>
                  <v-radio
                    :label="$dd_notification_template_type('email')"
                    value="email"
                    @change="typeChange('email')"
                    dense
                    hide-details
                  ></v-radio>
                  <v-radio
                    :label="$dd_notification_template_type('sms')"
                    value="sms"
                    @change="typeChange('sms')"
                    :disabled="!Boolean(organisation.sms_service)"
                    dense
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-if="type && module != 'participant'">
                <v-autocomplete
                  name="template"
                  v-model="template"
                  :items="templates"
                  item-text="subject"
                  item-value="id"
                  :label="$t('notificationtemplates.select_template')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('template')"
                  @change="templateChange"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 class="mb-2">
                <v-layout row wrap class="px-2">
                  <v-flex xs10>
                    <v-flex xs12 v-if="type" style="position: relative">
                      <br />
                      <v-menu :close-on-content-click="false" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="fab-tags darken-2 pa-1 text--white" small absolute top right icon
                            ><v-icon>format_list_bulleted</v-icon>
                          </v-btn>
                        </template>
                        <v-card width="400px">
                          <v-card-text>
                            <v-simple-table dense>
                              <tbody>
                                <tr>
                                  <td colspan="2" class="text-center">
                                    <b>{{ $t("notificationtemplates.available_tags") }}</b>
                                  </td>
                                </tr>
                                <tr v-for="(value, key) in tags" :key="key">
                                  <td class="pa-1" style="white-space: nowrap">
                                    <!--<v-chip small color="primary">{{ key }}</v-chip>-->{{ "{" + key + "}" }}
                                  </td>
                                  <td class="pa-1" style="border-left: 1px solid rgba(0, 0, 0, 0.2)">{{ value }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 v-if="type && type == 'email'">
                      <v-text-field
                        name="subject"
                        v-model="subject"
                        class="required-field"
                        v-validate="'required'"
                        :label="$t('notificationtemplates.subject')"
                        :error-messages="errors.collect('subject')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex xs2 v-if="type && type == 'email'" class="pl-4">
                    <v-checkbox v-model="cc_me" :label="$t('notificationtemplates.cc_me')" class="mt-0" hide-details></v-checkbox>
                    <v-checkbox v-model="bcc_me" :label="$t('notificationtemplates.bcc_me')" hide-details></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div v-if="type == 'sms'">
                  <v-textarea
                    name="message"
                    class="required-field sms-textarea"
                    v-validate="'required|dynamicMax:320,' + smsCounter.count"
                    v-model="message"
                    :label="$t('notificationtemplates.message')"
                    :error-messages="errors.collect('message')"
                    :auto-grow="true"
                    :hint="smsCounter.html"
                    :persistent-hint="true"
                  >
                    <template v-slot:message="{ message, key }">
                      <span v-html="message"></span>
                    </template>
                  </v-textarea>
                </div>
                <div v-if="type == 'email'">
                  <div class="required-field mb-1">{{ $t("notificationtemplates.message") }}</div>
                  <vue-editor
                    name="message"
                    class="vue2editor"
                    :editor-toolbar="customToolbar"
                    v-validate="'required'"
                    v-model="message"
                    :error-messages="errors.collect('message')"
                  ></vue-editor>
                  <div class="v-text-field__details mt-2">
                    <div class="v-messages theme--light error--text" role="alert">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{ errors.first("message") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <action-button type="notify" @click="send" :text="$t('global.send')" :disabled="!type" />
          <action-button type="cancel" @click="cancel" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor"
export default {
  name: "SendEmailTemplatePopup",

  components: { VueEditor },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    module: {
      type: String
    },
    module_id: {
      type: Number
    },
    selected_ids: {
      type: Array
    },
    selected_ids_module: {
      type: String
    }
  },

  data() {
    return {
      slug: "generic-course-email-template",
      type: null,
      template: null,
      subject: null,
      message: "",
      tags: [],

      all_templates: [],
      templates: [],
      organisation: {},

      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ list: "ordered" }, { list: "bullet" }]
      ],

      cc_me: false,
      bcc_me: false,

      dictionary: {
        attributes: {
          template: this.$t("notificationtemplates.template"),
          subject: this.$t("notificationtemplates.subject"),
          message: this.$t("notificationtemplates.message")
        }
      }
    }
  },

  watch: {
    show: {
      handler(val) {
        if (val) {
          this.init()
        }
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    smsCounter() {
      return this.$smsCounter(this.message, [
        { tag: "{organisation_name}", count: this.organisation && this.organisation.name ? this.organisation.name.length : 0 }
      ])
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {},

  methods: {
    init() {
      let modules = [
        { key: "organisation", module: "organisation", query: "resourcetype=basic" },
        { key: "notificationtemplates", module: "notificationtemplates", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", modules).then((res) => {
        this.organisation = res.data.organisation
        this.all_templates = res.data.notificationtemplates

        this.type = "email"
        this.typeChange("email")
      })
    },
    typeChange(type) {
      this.templates = this.all_templates.filter((i) => i.type == type)
      this.tags = this.$getGenericCourseEmailSMSTags(type, this.module)
      this.clearFields()
    },
    templateChange() {
      if (this.template) {
        let obj = this.templates.find((i) => i.id == this.template)

        if (obj) {
          this.subject = obj.subject
          this.message = obj.template
        }
      }
    },
    clearFields() {
      this.template = null
      this.subject = null
      this.message = ""
    },
    send() {
      this.$validator
        .validateAll()
        .then(() => {
          let data = {
            module_id: this.module_id,
            module: this.module,
            selected_ids: this.selected_ids ? this.selected_ids.join(",") : null,
            selected_ids_module: this.selected_ids_module,
            slug: this.slug,
            type: this.type,
            subject: this.subject,
            message: this.message,
            cc_me: this.cc_me,
            bcc_me: this.bcc_me
          }

          if (this.isFormValid) {
            axios
              .post(this.API_URL + "notificationtemplate/send", data)
              .then((res) => {
                this.$emit("callback_sendemailtemplatepopup_send_success", data)
              })
              .catch((err) => {
                this.$emit("callback_sendemailtemplatepopup_send_failed", data)
              })
              .finally(() => {
                this.clearFields()
                this.type = null
                this.cc_me = false
                this.bcc_me = false
              })
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch((e) => {
          console.log(e)
          this.$emit("callback_sendemailtemplatepopup_send_failed")
        })
    },
    cancel() {
      this.clearFields()
      this.$emit("callback_sendemailtemplatepopup_cancel")
    }
  }
}
</script>
<style>
.fab-tags {
  top: 5px !important;
  right: 0px !important;
  background-color: var(--v-primary-darken2) !important;
  color: var(--v-button_text-base) !important;
}
.vue2editor .ql-editor {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.sms-textarea .v-messages.error--text {
  text-align: left !important;
}
.sms-textarea .v-messages {
  text-align: right !important;
}
</style>
